import {useState} from 'react'
import HorizontalNavMenuItems from './HorizontalNavMenuItems'
import {PropTypes} from "prop-types"

const HorizontalMenu = ({currentActiveItem, routerProps}) => {
    const [activeItem, setActiveItem] = useState(null)
    const [groupActive, setGroupActive] = useState([])
    const [openDropdown, setOpenDropdown] = useState([])

    const onMouseEnter = id => {
        const arr = openDropdown
        arr.push(id)
        setOpenDropdown([...arr])
    }

    const onMouseLeave = id => {
        const arr = openDropdown
        arr.splice(arr.indexOf(id), 1)
        setOpenDropdown([...arr])
    }

    return (
        <div className='navbar-container main-menu-content'>
            <ul className='nav navbar-nav' id='main-menu-navigation'>
                <HorizontalNavMenuItems
                    submenu={false}
                    items={navigation}
                    activeItem={activeItem}
                    groupActive={groupActive}
                    routerProps={routerProps}
                    onMouseEnter={onMouseEnter}
                    onMouseLeave={onMouseLeave}
                    openDropdown={openDropdown}
                    setActiveItem={setActiveItem}
                    setGroupActive={setGroupActive}
                    setOpenDropdown={setOpenDropdown}
                    currentActiveItem={currentActiveItem}
                />
            </ul>
        </div>
    )
}

HorizontalMenu.propTypes = {
    currentActiveItem: PropTypes.string,
    routerProps: PropTypes.object.isRequired
}

HorizontalMenu.defaultProps = {
    currentActiveItem: null
}

export default HorizontalMenu
